import PaymentInfo from 'components/GlobalModals/PaidReservationModal/PaymentSection/PaymentSectionContent/PaymentInfo/PaymentInfo';

export default PaymentInfo;
